<div class="loading-spinner" role="status" [attr.aria-label]="displayLabel">
  <div class="spinner-orbit" aria-hidden="true">
    <span class="spinner-core"></span>
    <span class="spinner-dot spinner-dot-one"></span>
    <span class="spinner-dot spinner-dot-two"></span>
    <span class="spinner-dot spinner-dot-three"></span>
  </div>
  <span class="loading-label">{{ displayLabel }}</span>
</div>